/* Form Page to edit walkies */
import React, { useEffect, useState } from "react"
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Container from "react-bootstrap/Container"
import styles from "../../styles/PostCreateEditForm.module.css"
import appStyles from "../../App.module.css"
import btnStyles from "../../styles/Button.module.css"
import Alert from "react-bootstrap/Alert"
import toast from "react-hot-toast";

import { useHistory, useParams } from "react-router-dom"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import TopBox from "../../components/TopBox"
import { useRedirect } from "../../hooks/Redirect"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"

const WalkiesEdit = () => {
  useRedirect()
  const host = useHostName()
  const [errors, setErrors] = useState({})

  const [postData, setPostData] = useState({
    walkie_channel_production: "",
    walkie_channel_open: "",
    walkie_channel_transportation: "",
    walkie_channel_art_dept: "",
    walkie_channel_rollover: "",
    walkie_channel_camera: "",
    walkie_channel_electric: "",
    walkie_channel_grip: "",
  })

  const {
    walkie_channel_production,
    walkie_channel_open,
    walkie_channel_transportation,
    walkie_channel_art_dept,
    walkie_channel_rollover,
    walkie_channel_camera,
    walkie_channel_electric,
    walkie_channel_grip,
  } = postData;

  //  const [postData, setPostData] = useState({
  //     name: "",
  //     description: "",
  //     filming_address_primary: "",
  //     filming_address2: "",
  //     filming_address3: "",
  //     image1_description: "",
  //     image2_description: "",
  //     image3_description: "",
  //   })
  // const {name,
  //     description,
  //     filming_address_primary,
  //     filming_address2,
  //     filming_address3,
  //     image1_description,
  //     image2_description,
  //     image3_description} = postData;

  const history = useHistory()
  const { id } = useParams()

  // 1. **** 
  useEffect(() => {
    const handleMount = async () => {
      try {
        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const { data } = await axiosReq.get(`/masters/walkies/${id}/`)
          if (data?.success === false) {
            throw data.error;
          }
          const {
            walkie_channel_production,
            walkie_channel_open,
            walkie_channel_transportation,
            walkie_channel_art_dept,
            walkie_channel_rollover,
            walkie_channel_camera,
            walkie_channel_electric,
            walkie_channel_grip,
          } = data
          setPostData({
            walkie_channel_production,
            walkie_channel_open,
            walkie_channel_transportation,
            walkie_channel_art_dept,
            walkie_channel_rollover,
            walkie_channel_camera,
            walkie_channel_electric,
            walkie_channel_grip,
          })
        } else {
          const response = await axiosInstance.get(
            `${localStorage.getItem("projectSlug")}/masters/walkies/${id}/`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
              withCredentials: true,
            }
          )
          if (response?.success === false) {
            throw response.error;
          }
          const { data } = response;
          const {
            walkie_channel_production,
            walkie_channel_open,
            walkie_channel_transportation,
            walkie_channel_art_dept,
            walkie_channel_rollover,
            walkie_channel_camera,
            walkie_channel_electric,
            walkie_channel_grip,
          } = data
          setPostData({
            walkie_channel_production,
            walkie_channel_open,
            walkie_channel_transportation,
            walkie_channel_art_dept,
            walkie_channel_rollover,
            walkie_channel_camera,
            walkie_channel_electric,
            walkie_channel_grip,
          })
          //   const {
          //     name,
          // description,
          // filming_address_primary,
          // filming_address2,
          // filming_address3,
          // image1_description,
          // image2_description,
          // image3_description,
          //   } = data
          //   setPostData({
          //     name,
          // description,
          // filming_address_primary,
          // filming_address2,
          // filming_address3,
          // image1_description,
          // image2_description,
          // image3_description,
          //   })
        }
      } catch (err) {
        console.log(err)
        const backendError =
          err?.response?.data?.error ||
          err?.response?.data?.detail ||
          "Failed to load Walkies.";
        toast.error(backendError)
      }
    }

    handleMount()
    // eslint-disable-next-line
  }, [id])

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    const payload = {
      walkie_channel_production,
      walkie_channel_open,
      walkie_channel_transportation,
      walkie_channel_art_dept,
      walkie_channel_rollover,
      walkie_channel_camera,
      walkie_channel_electric,
      walkie_channel_grip,
    }

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const response = await axiosReq.put(`/masters/walkies/${id}/`, payload, {
          headers: { "Content-Type": "application/json" },
        })
        if (response?.success === false) {
          throw response.error;
        }
        history.push(`/${localStorage.getItem("projectSlug")}/walkies/`)
        toast.success(`Walkies Updated`);
      } else {
        const response = await axiosInstance.put(
          `${localStorage.getItem("projectSlug")}/masters/walkies/${id}/`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        if (response?.success === false) {
          throw response.error;
        }
        history.push(`/${localStorage.getItem("projectSlug")}/walkies/`)
        toast.success(`Walkies Updated Successfully!`);
      }
    } catch (err) {
      console.log(err)
      const detailMessage =
        err?.response?.data?.error ||
        err?.response?.data?.detail ||
        err?.response?.data?.message ||
        "Failed to update Walkies."
      toast.error(detailMessage)
      if (err.response?.status !== 401) {
        setErrors(err.response?.data)
      }
    }
  }

  const buttons = (
    <div className="text-center">
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
        onClick={() => history.goBack()}
      >
        Cancel
      </Button>
      <Button className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 ml-3`} type="submit">
        Update
      </Button>
    </div>
  )

  return (
    <div>
      <TopBox
        title={`Walkies`}
        title3="Edit" />
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} text-left my-2`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <Container className={`px-0 ${appStyles.Content} ${styles.Container}`}>
        <h5 className={`text-center mt-0 mb-2 py-1 ${styles.SubTitle}`}
          style={{ textTransform: 'uppercase' }}>EDIT WALKIES</h5>
        <Form className="mt-3" onSubmit={handleSubmit}>
          <div className="mt-3 text-center">
            <Row className="pt-2">
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
                <Form.Group controlId="walkie_channel_production" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Production</Form.Label>
                  <Form.Control
                    className={`${styles.Input}`}
                    type="text"
                    name="walkie_channel_production"
                    value={walkie_channel_production}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.walkie_channel_production?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
                <Form.Group controlId="walkie_channel_open" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Open</Form.Label>
                  <Form.Control
                    className={`${styles.Input}`}
                    type="text"
                    name="walkie_channel_open"
                    value={walkie_channel_open}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.walkie_channel_open?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
                <Form.Group controlId="walkie_channel_transportation" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Transport</Form.Label>
                  <Form.Control
                    className={`${styles.Input}`}
                    type="text"
                    name="walkie_channel_transportation"
                    value={walkie_channel_transportation}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.walkie_channel_transportation?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
                <Form.Group controlId="walkie_channel_art_dept" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Art Dept</Form.Label>
                  <Form.Control
                    className={`${styles.Input}`}
                    type="text"
                    name="walkie_channel_art_dept"
                    value={walkie_channel_art_dept}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.walkie_channel_art_dept?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
            </Row>
            <hr className="mb-1" />
            <Row>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
                <Form.Group controlId="walkie_channel_rollover" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Rollover</Form.Label>
                  <Form.Control
                    className={`${styles.Input}`}
                    type="text"
                    name="walkie_channel_rollover"
                    value={walkie_channel_rollover}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.walkie_channel_rollover?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
                <Form.Group controlId="walkie_channel_camera" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Camera</Form.Label>
                  <Form.Control
                    className={`${styles.Input}`}
                    type="text"
                    name="walkie_channel_camera"
                    value={walkie_channel_camera}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.walkie_channel_camera?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
                <Form.Group controlId="walkie_channel_electric" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Electric</Form.Label>
                  <Form.Control
                    className={`${styles.Input}`}
                    type="text"
                    name="walkie_channel_electric"
                    value={walkie_channel_electric}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.walkie_channel_electric?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
                <Form.Group controlId="walkie_channel_grip" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Grip</Form.Label>
                  <Form.Control
                    className={`${styles.Input}`}
                    type="text"
                    name="walkie_channel_grip"
                    value={walkie_channel_grip}
                    onChange={handleChange}
                  />
                </Form.Group>
                {errors?.walkie_channel_grip?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))}
              </Col>
            </Row>
          </div>
          {/* <div className="mt-3 text-center"> 
          <Row className="pt-2">
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
              <Form.Group controlId="name" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Production</Form.Label>
                  <Form.Control 
                  className={`${styles.Input}`}
                  type="text"
                  name="name"
                  value={name}
                  onChange={handleChange}
                      />
              </Form.Group>
              {errors?.name?.map((message, idx) => (
                <Alert variant="warning" key={idx}>
                  {message}
                </Alert>
              ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
              <Form.Group controlId="description" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Open</Form.Label>
                  <Form.Control 
                  className={`${styles.Input}`}
                  type="text"
                  name="description"
                  value={description}
                  onChange={handleChange}
                      />
              </Form.Group>
              {errors?.description?.map((message, idx) => (
                <Alert variant="warning" key={idx}>
                  {message}
                </Alert>
              ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
              <Form.Group controlId="filming_address_primary" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Transport</Form.Label>
                  <Form.Control 
                  className={`${styles.Input}`}
                  type="text"
                  name="filming_address_primary"
                  value={filming_address_primary}
                  onChange={handleChange}
                      />
              </Form.Group>
              {errors?.filming_address_primary?.map((message, idx) => (
                <Alert variant="warning" key={idx}>
                  {message}
                </Alert>
              ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
              <Form.Group controlId="filming_address2" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Art Dept</Form.Label>
                  <Form.Control 
                  className={`${styles.Input}`}
                  type="text"
                  name="filming_address2"
                  value={filming_address2}
                  onChange={handleChange}
                      />
              </Form.Group>
              {errors?.filming_address2?.map((message, idx) => (
                <Alert variant="warning" key={idx}>
                  {message}
                </Alert>
              ))}
              </Col>
          </Row>
          <hr className="mb-1"/>
          <Row>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
              <Form.Group controlId="filming_address3" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Rollover</Form.Label>
                  <Form.Control 
                  className={`${styles.Input}`}
                  type="text"
                  name="filming_address3"
                  value={filming_address3}
                  onChange={handleChange}
                      />
              </Form.Group>
              {errors?.filming_address3?.map((message, idx) => (
                <Alert variant="warning" key={idx}>
                  {message}
                </Alert>
              ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
              <Form.Group controlId="image1_description" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Camera</Form.Label>
                  <Form.Control 
                  className={`${styles.Input}`}
                  type="text"
                  name="image1_description"
                  value={image1_description}
                  onChange={handleChange}
                      />
              </Form.Group>
              {errors?.image1_description?.map((message, idx) => (
                <Alert variant="warning" key={idx}>
                  {message}
                </Alert>
              ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
              <Form.Group controlId="image2_description" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Electric</Form.Label>
                  <Form.Control 
                  className={`${styles.Input}`}
                  type="text"
                  name="image2_description"
                  value={image2_description}
                  onChange={handleChange}
                      />
              </Form.Group>
              {errors?.image2_description?.map((message, idx) => (
                <Alert variant="warning" key={idx}>
                  {message}
                </Alert>
              ))}
              </Col>
              <Col xs={3} className="d-flex justify-content-center p-0 p-md-2">
              <Form.Group controlId="image3_description" className={`${styles.Width} `}  >
                  <Form.Label className={`${styles.BoldScene} `} >Grip</Form.Label>
                  <Form.Control 
                  className={`${styles.Input}`}
                  type="text"
                  name="image3_description"
                  value={image3_description}
                  onChange={handleChange}
                      />
              </Form.Group>
              {errors?.image3_description?.map((message, idx) => (
                <Alert variant="warning" key={idx}>
                  {message}
                </Alert>
              ))}
              </Col>
          </Row>
          </div>  */}
          <Row>
            <Col>
              <Container className={`${styles.Container} mt-3`} >{buttons} </Container>
            </Col>
          </Row>
        </Form>
      </Container>
    </div>
  )
}

export default WalkiesEdit
